import React from 'react'
import { useLinkedOpportunityAnalysisCount } from '../hooks/useLinkedOpportunityAnalysisCount'

type AnalysisLinkedOpportunityNoticeProps = {
  opportunityId: number | null
  excludeAnalysisId?: number | null
  visible?: boolean
}

export function AnalysisLinkedOpportunityNotice({
  opportunityId,
  excludeAnalysisId = null,
  visible = true,
}: AnalysisLinkedOpportunityNoticeProps) {
  const { count, loading, error } = useLinkedOpportunityAnalysisCount(
    opportunityId,
    excludeAnalysisId,
    visible,
  )

  if (!visible || opportunityId == null) return null

  if (loading) {
    return (
      <div className="text-xs text-foreground/60">
        Verificando publicacoes existentes...
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-xs text-foreground/60">
        Nao foi possivel verificar publicacoes existentes.
      </div>
    )
  }

  if (count <= 0) return null

  const label =
    count === 1
      ? 'Ja existe 1 analise publicada para esta oportunidade.'
      : `Ja existem ${count} analises publicadas para esta oportunidade.`

  return (
    <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-200">
      {label}
    </div>
  )
}
